import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import {request} from "../../../api-client";
import localization from "../../../config/localization";
import {ArrowForward, Block, FilterNone, Person, Restore} from "@material-ui/icons";
import LinkIcon from '@material-ui/icons/Link';
import TableButton from "../../../components/Letflow/Table/Buttons/TableButton";
import {getStoredUser, homePathGenerator, slugify} from "../../../api-client/core/authentication/utils";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {red} from "@material-ui/core/colors";
import {addHttpToUrl} from "../../../utils";
import {Link} from "react-router-dom";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";

class LinksTable extends Component {
  state = {
    total: "",
    showLinks: "all",
    links: this.props.links,
    search: '',
    checked: getStoredUser().show_link_notification,
    copied: localization.get('copy_link')
  };

  handleAlertClosed = artistId => status => {
    if (status === "passed") this.refs.table.removeById(artistId);
  };

  writeTooltipText = () => {
    this.setState({copied: localization.get('copied')})
    setTimeout(
      () => this.setState({copied: localization.get('copy_link')}),
      2000
    )
  }

  buttons = link => {
    const { expired_at, id } = link;

    const buttonBuilder = new TableButtonsBuilder();

    buttonBuilder.withOther(
      <TableButton
        title={this.state.copied}
      >
        <CopyToClipboard
          text={`${this.getLink(link)}`}
          style={{bottom: 5, fontSize: 20}}
          onCopy={this.writeTooltipText}
          title={this.state.copied}
        >
          <FilterNone/>
        </CopyToClipboard>
      </TableButton>
    );
    {
      expired_at ?
        buttonBuilder.withOther(
          <TableButton
            title={localization.get('link_activate')}
            onClick={() => request.shareLink.restore(id).then(this.refs.table.forceUpdate)}
          >
            <Restore/>
          </TableButton>
        )
        :
        buttonBuilder.withOther(
          <TableButton
            title={localization.get('link_expire')}
            onClick={() => request.shareLink.expire(id).then(this.refs.table.forceUpdate)}
          >
            <Block/>
          </TableButton>
        )
    }

    buttonBuilder.withOther(
      <Link
        to={addHttpToUrl(this.getLink(link))}
        target={"_blank"}
      >
        <TableButton
          title={localization.get('links.go_to')}
        >
          <ArrowForward/>
        </TableButton>
      </Link>
      );

    return buttonBuilder.build();
  };

  columns = () => [
    {
      Header: localization.get("table.share_material"),
      accessor: "material",
      filterable: false,
      sortable: false,
      Cell: shortLink => <span style={{ color: this.rowExpired(shortLink.original)}}>{this.getMaterialType(shortLink.original)}</span>
    },
    {
      Header: localization.get("table.detail"),
      id: 'owner',
      accessor: shortLink =>  (shortLink.owner) ? shortLink.owner.name || shortLink.owner.title : '',
      filterable: false,
      sortable: false,
      show: window.innerWidth > 635,
      Cell: shortLink => <span style={{ color: this.rowExpired(shortLink.original)}}>{shortLink.value}</span>
    },
    {
      Header: localization.get("table.created_at"),
      id: "created_at",
      accessor: shortLink => localization.moment(shortLink.created_at).fromNow(),
      filterable: false,
      sortable: false,
      show: window.innerWidth > 935,
      Cell: shortLink => <span style={{ color: this.rowExpired(shortLink.original)}}> {shortLink.value} </span>
    },
    {
      Header: localization.get("table.to"),
      id: 'to',
      filterable: false,
      sortable: false,
      accessor: shortLink => shortLink.target,
      Cell: shortLink => <span style={{ color: this.rowExpired(shortLink.original)}}>{shortLink.original.target}</span>
    },
    {
      Header: localization.get('table.views'),
      id: 'views',
      accessor: "views",
      filterable: false,
      sortable: true,
      minWidth: 70,
      show: window.innerWidth > 715,
      Cell: shortLink => <span style={{ color: this.rowExpired(shortLink.original)}}> {shortLink.value} </span>
    },
    {
      Header: localization.get("table.last_view"),
      id: "updated_at",
      filterable: false,
      sortable: true,
      show: window.innerWidth > 825,
      Cell: shortLink => <span style={{ color: this.rowExpired(shortLink.original)}}> {localization.moment(shortLink.original.updated_at).fromNow()} </span>
    },
    {
      id: "actions",
      Header: () => <div style={{paddingRight: "10px"}}>{localization.get("table.actions")}</div>,
      sortable: false,
      filterable: false,
      accessor: this.buttons,
      maxWidth: 145,
      minWidth: window.innerWidth > 425 ? 120 : 79,
      Footer: (
        <span style={{ float: "right", fontSize: "18px", marginTop: "15px", paddingRight: "5px" }}>
          <strong>Total: </strong>
          {this.state.total}
        </span>
      )
    }
  ];

  getMaterialType = link => {
    if (link.owner_type.indexOf("ContentCreator") !== -1) {
      return localization.get('content_creator')
    } else if (link.owner_type.indexOf("ContentCreation") !== -1) {
      return localization.get('content_creation')
    }else if (link.owner_type.indexOf("Playlist") !== -1) {
      return localization.get('playlist')
    }else if (link.owner_type.indexOf("Reel") !== -1) {
      return localization.get('reel')
    }
    return ""
  }

  getLink = link => {
    if (link.owner_type.indexOf("ContentCreator") !== -1) {
      return `${window.location.protocol}//${window.location.hostname}/public/content_creators/${link.hashcode}`
    } else if (link.owner_type.indexOf("ContentCreation") !== -1) {
      return `${window.location.protocol}//${window.location.hostname}/public/content_creations/${link.hashcode}`
    }else if (link.owner_type.indexOf("Playlist") !== -1) {
      return `${window.location.protocol}//${window.location.hostname}/public/playlists/${link.hashcode}`
    }else if (link.owner_type.indexOf("Reel") !== -1) {
      return `${window.location.protocol}//${window.location.hostname}/public/reel/${link.hashcode}`
    }
    return ""
  }

  rowExpired = link => link.expired_at ? red['500'] :  '#3C4858'

  handleSearch = (search) => {
    this.setState({search: search});
    this.refs.table.forceUpdate()
  };

  render = () => {
    return (
      <div>
        <div style={{display: 'flex', justifyContent: 'space-between', padding: "50px 0px 10px"}}>
          <div className="favorites-section-title">
            <div style={{
              textTransform: 'uppercase',
              display: 'flex',
              alignItems: 'center',
              fontSize: 18,
              fontWeight: 'bold',
              lineHeight: '36px',
              marginBottom: '20px'
            }}><LinkIcon style={{marginRight: 5, fontSize: 28}}/>{localization.get("navbar_sidebar.smart_share")}</div>
          </div>
          <HomeSearchInput
            styles={{marginBottom: 20}}
            value={this.state.search}
            placeholder={"smart_share.search"}
            onSearch={value => this.handleSearch(value)}
          />
        </div>
        {getStoredUser().contentCreator && getStoredUser().contentCreator.active &&
          <div style={{display: 'flex', justifyContent: 'center', padding: "50px 0px 10px"}}>
            <div style={{
              textTransform: 'uppercase',
              display: 'flex',
              alignItems: 'center',
              fontSize: 18,
              fontWeight: 'bold',
              lineHeight: '36px',
              marginBottom: '20px',
              border: '1px solid #ccc',
              flexDirection: "row",
              justifyContent: "space-between",
              minWidth: "30%",
              borderRadius: 5,
              position: "relative"
            }}>
              <Link
                style={{textDecoration: "none", marginRight: 5, width: 50, height: 50, padding: 6, borderRight:" 1px solid #ccc"}}
                to={!getStoredUser().contentCreator.profile_url ? homePathGenerator(`contenido/${getStoredUser().contentCreator.id}-${slugify(getStoredUser().contentCreator.name)}`) : `${window.location.protocol}//${window.location.hostname}/bl/${getStoredUser().contentCreator.profile_url}`}
              >
                <Person style={{fontSize: 34, color: "#4e4d58"}}/>
              </Link>
              <p style={{width: "70%"}}>{localization.get("profile_views")}</p>
              <div style={{fontSize: 28, minWidth: "15%", height: 50, padding: 8, textAlign: "center", borderLeft:" 1px solid #ccc"}}>{getStoredUser().contentCreator.views}</div>
            </div>
          </div>
        }
        <div style={{ width: "100%", float: "left", position: "relative" }}>
          <ServerSidePaginationTable
            ref="table"
            columns={this.columns()}
            showPaginationBottom={true}
            showCustomPagination={true}
            requestTableData={paginationConfig => {
              if (this.state.search) {
                paginationConfig = {
                  ...paginationConfig,
                  filterBy: paginationConfig.filterBy.concat([{column: 'target', filter: this.state.search}])
                }
              }

              return request.shareLink.getAll(paginationConfig)
                .then(response => {
                  this.setState({ total: response.meta.total });
                  return response;
                });
            }}
          />
        </div>
      </div>
    )
  };
}

export default LinksTable;
